import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import Typography from "../../typography";
import { AccountItems, NavItems } from "./navitems";
import { useLocation, useNavigate } from "react-router-dom";
import { Colors } from "../../../utils/colors";
import AccountItem from "components/account-component";
import { IUser } from "types/user";
import { GetUser } from "services/user/getUser";
import { LogOut } from "services/user/logOut";

const DashboardSidebar = () => {
  const path = useLocation().pathname;
  const navigate = useNavigate();

  const [user, setUser] = useState<IUser>();
  const User = useMemo(() => GetUser(), []);

  useEffect(() => {
    if (User) {
      setUser(User);
    }
  }, [User, user]);

  return (
    <Container>
      {NavItems.map(({ name, link, activeIcon, inactiveIcon }, i) => {
        const ItemActive = path.includes(link);

        return (
          <NavButton
            key={i}
            onClick={() => navigate(link)}
            active={ItemActive ? "true" : "false"}
          >
            <Icon>{ItemActive ? activeIcon : inactiveIcon}</Icon>
            <Typography
              ml="2"
              color={ItemActive ? Colors.white100 : Colors.grey500}
              weight={ItemActive ? "medium" : "regular"}
              size="xl"
              m_size="lg"
            >
              {name}
            </Typography>
          </NavButton>
        );
      })}
      <AccoutContainer>
        <Typography mt="2.4" ml="2.4" color={Colors.grey300} weight="medium">
          Account
        </Typography>
        <AccountBody>
          {user && <AccountItem name={user.name} email={user.email} />}
        </AccountBody>
        {AccountItems.map(({ name, link, activeIcon, inactiveIcon }, i) => {
          const ItemActive = path.includes(link);

          return (
            <NavButton
              key={i}
              onClick={() => navigate(link)}
              active={ItemActive ? "true" : "false"}
            >
              <Icon>{ItemActive ? activeIcon : inactiveIcon}</Icon>
              <Typography
                ml="2"
                color={ItemActive ? Colors.white100 : Colors.grey500}
                weight={ItemActive ? "medium" : "regular"}
                size="xl"
              >
                {name}
              </Typography>
            </NavButton>
          );
        })}
        <NavButton
          onClick={() => {
            LogOut();
          }}
        >
          <Icon>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M7.5 3.75H6.66667C4.70248 3.75 3.72039 3.75 3.11019 4.36019C2.5 4.97039 2.5 5.95248 2.5 7.91667L2.5 12.0833C2.5 14.0475 2.5 15.0296 3.11019 15.6398C3.72039 16.25 4.70248 16.25 6.66667 16.25H7.5"
                stroke="#909090"
                stroke-width="1.5"
              />
              <path
                d="M7.5 5.39683C7.5 3.48532 7.5 2.52958 8.08937 2.00708C8.67875 1.48459 9.57958 1.64172 11.3813 1.95597L13.322 2.29445C15.3174 2.64248 16.3151 2.81649 16.9076 3.54838C17.5 4.28027 17.5 5.33877 17.5 7.45576V12.5439C17.5 14.6609 17.5 15.7194 16.9076 16.4512C16.3151 17.1832 15.3174 17.3572 13.322 17.7053L11.3813 18.0437C9.57958 18.3579 8.67875 18.5151 8.08937 17.9926C7.5 17.4701 7.5 16.5143 7.5 14.6028L7.5 5.39683Z"
                stroke="#909090"
                stroke-width="1.5"
              />
              <path
                d="M10 9.1665V10.8332"
                stroke="#909090"
                stroke-width="1.5"
                stroke-linecap="round"
              />
            </svg>
          </Icon>
          <Typography
            ml="2"
            color={Colors.grey500}
            weight={"regular"}
            size="xl"
          >
            Sign out
          </Typography>
        </NavButton>
      </AccoutContainer>
    </Container>
  );
};

export default DashboardSidebar;

const Container = styled.div`
  height: 100%;
  width: 100%;
  padding: 3rem 1.5rem 4rem 1.5rem;
  display: flex;
  flex-direction: column;
  background-color: ${Colors.grey1000};
  position: relative;
  z-index: 3;

  @media only screen and (max-width: 769px) {
    padding: 3.2rem 1.6rem;
    padding-bottom: 4rem;
  }
`;

const NavButton = styled.div<{ active?: string }>`
  width: 100%;
  margin-bottom: 1rem;
  padding: 1rem 2.4rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-radius: 0.8rem;
  border: ${(props) =>
    props.active === "true" ? "1px solid #252525" : "1px solid transparent"};
  background: ${(props) =>
    props.active === "true"
      ? " linear-gradient(90deg, #131313 0%, #252525 100%)"
      : "none"};

  &:hover {
    border: 1px solid ${Colors.grey500};
  }

  transition: ease all 0.2s;

  @media only screen and (max-width: 769px) {
    padding: 1.2rem 2.4rem;
    margin-bottom: 1rem;
  }
`;

const Icon = styled.div`
  width: 2rem;
`;

const AccoutContainer = styled.div`
  margin-top: auto;
  @media only screen and (max-width: 769px) {
    margin-top: 1.6rem;
  }
`;

const AccountBody = styled.div`
  padding-left: 2.4rem;
`;
